import axios, { AxiosResponse } from 'axios';
import querystring from 'querystring';

export const order = {
  getOrderHistory: (count: number, payload): Promise<AxiosResponse> =>
    axios.get(`/orderhistory/orders?count=${count}`, payload),

  getFulfilmentStatus: (orderId: number): Promise<AxiosResponse> =>
    axios.get(`/order/fulfillmentstatus?orderId=${orderId}`),

  getCrossSellMenuItemIds: (
    limit: number,
    menuId: number,
    menuItemIds: number[],
    totalValue: number,
  ): Promise<AxiosResponse> => {
    const menuItemId = querystring.stringify({ menuItemId: menuItemIds });
    return axios.get(
      `/crossSell/menuItems?limit=${limit}&menuId=${menuId}&${menuItemId}&totalValue=${totalValue}`,
    );
  },
};
